/* eslint-disable max-len */

export const MgmMainPageResourcesEn = {
  goodieAdvantages: {
    title: "<b>Advantages</b> of goodie cashback",
  },

  cta: {
    receiverBonusAmount: "{receiverBonus} zł bonus is waiting for you!",
    description: "To redeem the promotion, <b>verify the telephone number</b>",
    button: "Verify",

    missingTrxTitle: "Your bonus is waiting for you!",
    missingTrxDescription: "Do your first purchase with goodie cashback to receive bonus",
    missingTrxButton: "Begin purchase",
  },

  dashboard: {
    title: "Recommend and <b>earn</b>",
    bonusDescription: "{senderBonus} zł for you and {receiverBonus} zł for your friend",

    inputTitle: "<b>Share</b> the code with a friend",

    referralLabel: "Your referral link",
    referralBtnShare: "Share",
    referralBtnCopy: "Copy link",
    referralCopied: "Copied",

    shareCodeMessage: "Hello! 😄 I recommend you the goodie app by which you can recover up to 25% of online shopping expenses in more than 800 stores. If you use my link, you will receive a bonus - {receiverBonus} PLN cashback. 🤩 Register in the app using the link below, choose a store, where you'd like to purchase goods, switch there via goodie, do shopping as usual and cashback will be yours! Check it - the goodie app is safe and totally free. ✅",
    shareCodeTitle: "goodie cashback - up to 25% cashback for online purchases!",

    codeLabel: "Your referral code",
    codeBtn: "Change code",
  },

  changeCode: {
    title: "Change code",
    description: "You can create your personal referral code, which is attributed only to you.  Bonuses from all you recommendations will appear on your account.",
    descriptionWarning: "<b>Attention!</b> If you change the code (you can do it max 3 times), your previous one will expire and your friends will not be able to use it.",
    inputPlaceholder: "Enter the code",
    btnUpdate: "Save",
    btnBack: "Cancel",
    errorGeneric: "Your code should be between 3 and 12 characters, letters and numbers only. Please choose a code that meets these requirements.",

  },

};
